module.exports = __webpack_public_path__ + "static/media/clouds-moon.e4102c2e.svg";